import { Button, Col, Container, FloatingLabel, Form, Row, Alert } from "react-bootstrap";
import emailjs from '@emailjs/browser';
import { useLoadingContext } from "../context/LoadingContext";
import ScaleLoader from "react-spinners/ClipLoader";
import { useState } from "react";

export function Contact() {
    const { loading } = useLoadingContext();
    const { setLoading } = useLoadingContext();
    const [showAlert, setShowAlert] = useState(false);
    const [showError, setShowError] = useState(false);

    function sendMail(e) {
        setLoading(true);
        e.preventDefault();
        setShowAlert(false);
        setShowError(false);

        emailjs.sendForm('service_ydu5f88', 'template_jh68mhj', e.target, 'user_PPpSpfPeJ2bq8l4t9Al08')
            .then((result) => {
                console.log(result.text);
                setLoading(false);
                setShowAlert(true);
            }, (error) => {
                console.log(error.text);
                setLoading(false);
                setShowError(true);
            });
    }

    return (
        <Container id="contact" fluid className="bg-enhanced-purple bg-particles bg-hexagon-pattern skewedRightTop section-padding">
            <div className="skewedRightContent">
                {/* Particle System */}
                <div className="particle-system">
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                    <div className="bg-particle"></div>
                </div>
                
                {loading && (
                    <div className="loader">
                        <ScaleLoader color={"var(--accent-gold)"} loading={loading} size={25} />
                    </div>
                )}
                
                <div className="container-modern">
                    <div className="text-center mb-5 fade-in">
                        <h2 className="font-type heading-lg text-light hoofding">Contact</h2>
                        <div className="text-light text-lg">
                            <p className="mb-3">Zin om ook eens mee te dansen?</p>
                            <p className="mb-3">Zit je met een vraag die je graag beantwoord ziet?</p>
                            <p className="mb-0">Contacteer ons dan via onderstaand formulier.</p>
                        </div>
                    </div>

                    <Row className="g-4 justify-content-center">
                        <Col lg={6} md={12}>
                            <div className="card-modern slide-in-left">
                                <div className="card-modern-header">
                                    <h3 className="card-modern-title">Stuur ons een bericht</h3>
                                    <p className="text-muted mb-0">Alle velden gemarkeerd met (*) zijn vereist</p>
                                </div>
                                
                                <Form onSubmit={sendMail}>
                                    <Row className="g-3">
                                        <Col md={6}>
                                            <div className="form-floating-modern">
                                                <label className="form-label-modern">Naam *</label>
                                                <input 
                                                    required 
                                                    name="from_lastName" 
                                                    type="text" 
                                                    placeholder="Voer uw naam in"
                                                    className="form-control-modern"
                                                />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-floating-modern">
                                                <label className="form-label-modern">Voornaam *</label>
                                                <input 
                                                    required 
                                                    name="from_firstName" 
                                                    type="text" 
                                                    placeholder="Voer uw voornaam in"
                                                    className="form-control-modern"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    
                                    <div className="form-floating-modern">
                                        <label className="form-label-modern">Email *</label>
                                        <input 
                                            required 
                                            name="reply_to" 
                                            type="email" 
                                            placeholder="uw.email@voorbeeld.be"
                                            className="form-control-modern"
                                        />
                                    </div>
                                    
                                    <div className="form-floating-modern">
                                        <label className="form-label-modern">Onderwerp</label>
                                        <input 
                                            name="subject" 
                                            type="text" 
                                            placeholder="Onderwerp van uw bericht"
                                            className="form-control-modern"
                                        />
                                    </div>
                                    
                                    <div className="form-floating-modern">
                                        <label className="form-label-modern">Bericht</label>
                                        <textarea 
                                            name="message"
                                            placeholder="Typ hier uw bericht..."
                                            className="form-control-modern"
                                            rows="6"
                                            style={{ resize: 'vertical', minHeight: '120px' }}
                                        />
                                    </div>
                                    
                                    <div className="text-center">
                                        <button type="submit" className="btn-primary-modern">
                                            <i className="fas fa-paper-plane me-2"></i>
                                            Bericht Versturen
                                        </button>
                                    </div>
                                    
                                    {showAlert && (
                                        <div className="alert-modern alert-success-modern">
                                            <h6 className="mb-0">
                                                <i className="fas fa-check-circle me-2"></i>
                                                Bedankt, jouw bericht is ontvangen
                                            </h6>
                                        </div>
                                    )}
                                    
                                    {showError && (
                                        <div className="alert-modern alert-danger-modern">
                                            <h6 className="mb-0">
                                                <i className="fas fa-exclamation-triangle me-2"></i>
                                                Er ging iets mis, gelieve telefonisch contact op te nemen
                                            </h6>
                                        </div>
                                    )}
                                </Form>
                            </div>
                        </Col>
                        
                        <Col lg={6} md={12}>
                            <div className="card-modern slide-in-right">
                                <div className="card-modern-header">
                                    <h3 className="card-modern-title">Bezoek onze locatie</h3>
                                    <p className="text-muted mb-0">Gemeentelijke basisschool Octopus</p>
                                </div>
                                
                                <div className="position-relative overflow-hidden" style={{ borderRadius: 'var(--radius-md)', height: '300px' }}>
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2507.6090954505908!2d4.482831551310758!3d51.0603053510144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3e504f35e1095%3A0x390b9be95cd14c89!2sGemeentelijke%20basisschool%20Octopus!5e0!3m2!1snl!2sbe!4v1634635784684!5m2!1snl!2sbe"
                                        style={{ 
                                            border: "0", 
                                            width: "100%", 
                                            height: "100%",
                                            borderRadius: 'var(--radius-md)'
                                        }} 
                                        title="Locatie kaart" 
                                        allowFullScreen="" 
                                        loading="lazy"
                                    />
                                </div>
                                
                                <div className="mt-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="social-link-modern me-3">
                                            <i className="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-1 font-weight-bold">Adres</h6>
                                            <p className="text-muted mb-0">Gemeentelijke basisschool Octopus</p>
                                        </div>
                                    </div>
                                    
                                    <div className="d-flex align-items-center">
                                        <div className="social-link-modern me-3">
                                            <i className="fas fa-clock"></i>
                                        </div>
                                        <div>
                                            <h6 className="mb-1 font-weight-bold">Lesuren</h6>
                                            <p className="text-muted mb-0">Zie ons lessenrooster voor alle tijden</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </Container>
    );
}